<template>
  <div class="home">
    <head-com></head-com>
    <div class="main">
      <el-breadcrumb class="target" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">学习中心</el-breadcrumb-item>
        <el-breadcrumb-item>{{info.courseName}}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="detail cl">
        <div class="left bs fl">
          <i class="img-wrap">
            <img :src="info.coursePic" alt />
          </i>
          <!-- <video width="100%" height="100%" controls autoplay>
            <source src="movie.mp4" type="video/mp4" />
            <source src="movie.ogg" type="video/ogg" />
          </video>-->
        </div>
        <div class="info fl">
          <h3 class="title">{{info.courseName}}</h3>
          <div class="line">
            <span>讲师: {{info.courseTeacher}}</span>
            <span class="hour">课时: {{info.courseTotalHours}}课时</span>
          </div>
          <div class="line">课程分类：{{info.cateName}}</div>
          <ul class="plan cl">
            <li>
              <el-progress type="circle" :percentage="percent" :width="60"></el-progress>
            </li>
            <li>
              <p>已完成</p>
              <p class="cont">{{finished}}/{{info.courseTotalHours}}</p>
            </li>
            <li v-if="info == 'null'">
              <p>课程有效期</p>
              <p class="cont">{{info.courseEndLine}}</p>
            </li>
            <!-- <li>
              <p>下一个学习任务</p>
              <p class="cont">{{taskTitle}}</p>
            </li>-->
          </ul>
          <el-row>
            <el-button type="primary" @click="studyBtn">开始学习</el-button>
            <p style="float: right;   margin-top: 10px; margin-left: 25px; font-size: 20px;color: #c16607;">所有课程有效期为180天，请在有效期内完成学习</p>
          </el-row>
        </div>
      </div>
      <div class="downloadDiv" style="color: #c16607;">
        温馨提示：为了您有更好的学习体验，推荐使用谷歌浏览器！
        <el-button type="warning" size="small" plain @click="download64">下载谷歌浏览器/64位</el-button>
        <el-button type="warning" size="small" plain @click="download32">下载谷歌浏览器/32位</el-button>
      </div>
      <div class="tab bs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!-- <el-tab-pane label="课程介绍" name="first">
            <div class="block">
              <h3 class="tab-title">课程概述：</h3>
              <p>{{info.courseContent}}</p>
            </div>
          </el-tab-pane>-->
          <el-tab-pane label="课程目录" name="first">
            <div class="cate" v-for="(item, i) in catalog" :key="i">
              <h3 class="cate-tit">{{item.ccName}}</h3>
              <div v-for="(cate, k) in item.subCatalog" :key="k">
                <div
                  class="cate-list cl"
                >
                  <div class="list-l fl"
                  @click="
                      goDetail(
                        info.courseId,
                        regId,
                        cate.vid,
                        cate.ccId,
                        cate.courseDelayTime,
                        i,
                        k,
                        cate.courseOver,
                        cate.overStaus,
                        cate.resouceHours
                      )
                    ">
                    <i class="icon">
                      <img
                        v-if="cate.overStaus == 1"
                        class="progress"
                        src="../assets/images/finish.png"
                        alt
                      />
                      <img
                        v-if="cate.overStaus == 2"
                        class="progress"
                        src="../assets/images/progress.png"
                        alt
                      />
                    </i>
                    <i class="progress stop cur"></i>
                    <span class="inline">{{cate.ccName}}</span>
                  </div>
                  <div class="list-r fr">{{cate.resouceHours}}</div>
                </div>
              </div>
            </div>
            <div class="empty" v-if="!catalog.length">暂无数据!</div>
          </el-tab-pane>
          <!-- <el-tab-pane label="练习列表" name="third">
            <div class="practice" v-for="(exe, j) in exerciseList" :key="j">
              <p>{{exe.exerciseName}}</p>
              <el-button type="primary" @click="startExercise(exe.id)" size="small">进入练习</el-button>
            </div>
            <div class="empty" v-if="!exerciseList.length">暂无数据!</div>
          </el-tab-pane>-->
        </el-tabs>
      </div>
    </div>
    <footer-com></footer-com>
  </div>
</template>

<script>
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";
import http from "../api/module";
import { getExam } from "../api/service.js";

export default {
  name: "detailList",
  data() {
    return {
      activeName: "first",
      entpId: localStorage.getItem("entpId"),
      info: {},
      percent: 0,
      catalog: [],
      exerciseList: [],
      regId: "",
      studyList: [],
      nextInfo: {}
    };
  },
  components: {
    HeadCom,
    FooterCom
  },
  mounted() {
    this.regId = this.$route.query.reg;
    this.courseId = this.$route.query.course;
    this.getDetail();
    this.nextTask();
  },
  computed: {
    taskTitle() {
      var taskName = this.nextInfo.courseName;
      if (taskName == this.info.courseName) {
        taskName = this.nextInfo.ccParentName + "-" + this.nextInfo.ccName;
      } else {
        taskName =
          this.info.courseName +
          "-" +
          this.nextInfo.ccParentName +
          "-" +
          this.nextInfo.ccName;
      }
      return taskName;
    },
    // 已完成
    finished() {
      return this.info.ccCount == null ? 0 : this.info.ccCount;
    }
  },
  methods: {
    studyBtn() {
          http.getUserInfo({}).then((data) => {
            console.log(data);
            if (data.data.data.empHeadportrait == "") {
              this.$message.error({
                duration: 3000,
                message: "请先上传登记照",
              });
            } else if (data.data.data.empIdcardFront == "") {
              this.$message.error({
                duration: 3000,
                message: "用户还未进行实名认证，请先到个人中心实名认证",
              });
            } else if (data.data.data.empIdcardNegative == "") {
              this.$message.error({
                duration: 3000,
                message: "用户还未进行实名认证，请先到个人中心实名认证",
              });
            } else {
              this.$router.push({
                path: "/coursePlay",
                query: {
                  course: this.courseId,
                  reg: this.regId,
                },
              });
            }
          });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 获取课程详情
    getDetail() {
      http
        .getCourseDetail({
          courseId: this.courseId,
          regId: this.regId
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.info = data.data.data;
            this.catalog = this.info.catalog;
            this.exerciseList = this.info.exerciseList;
            var num = (this.info.ccCount / this.info.courseTotalHours) * 100;
            this.percent = num.toFixed(0) * 1;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {});
    },
    // 获取课程详情  下一个学习任务
    nextTask() {
      http
        .getNextTask({
          courseId: this.courseId
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.nextInfo = data.data.data;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {});
    },

    //开始练习
    startExercise(exerciseId) {
      let _this = this;
      let url = "exercise/exerciseDetailVerification";
      let data = { exerciseId: exerciseId, courseId: this.courseId };
      _this.$router.push({
        path: "/examDetail",
        query: {
          exerciseId: exerciseId,
          courseId: this.courseId
        }
      });
    },
    download32(){
      window.open("https://bdy.kq.hbzclm.com/84.0.4147.105_chrome32_stable_windows_installer.exe")
    },
    download64(){
      window.open("https://bdy.kq.hbzclm.com/ChromeSetup.exe")
    },
        //点击目录开始学习
    goDetail(
      course, 
      reg, 
      vid,
      ccId, 
      courseDelayTime,
      index,
      sub,
      courseOver,
      overStaus, 
      resouceHours
      ) {
      localStorage.setItem('dataType',this.$route.query.dataType)
      var _this = this;
      const getVideoIdsParams = { 
        ccId,
        regId:_this.regId
      }
      http.getVideoId(getVideoIdsParams).then((getVideoIdsRes) =>{
        if(getVideoIdsRes.data.success){
        http.getUserInfo({}).then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            if (data.data.data.empHeadportrait != "") {
              if (
                data.data.data.empIdcardFront != "" &&
                data.data.data.empIdcardNegative != ""
              ) {
                _this.$router.push({
                  path: "/coursePlay",
                  query: {
                    course: course,
                    reg: reg,
                    vid: vid,
                    ccId: ccId,
                    courseDelayTime: courseDelayTime,
                    overStaus: overStaus,
                    courseOver: courseOver,
                    liSelected: index + "-" + sub,
                    resouceHours: resouceHours,
                  },
                });
              } else {
                this.$message.error({
                  duration: 3000,
                  message: "用户还未进行实名认证，请先到个人中心实名认证",
                });
              }
            } else {
              this.$message.error({
                duration: 3000,
                message: "请先上传登记照",
              });
            }
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
        }).catch((error) => {});
        }else{
          this.$message.error(getVideoIdsRes.data.message);
        }
       }
      )
    },
  }
};
</script>
<style lang="less" scoped>
.target {
  line-height: 60px;
}
.detail {
  .left {
    width: 500px;
    height: 300px;
    background: #ffffff;
    padding: 12px;
    .img-wrap {
      display: inline-block;
      width: 100%;
      height: 100%;
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  .info {
    margin-left: 30px;
    .title {
      line-height: 60px;
      font-size: 20px;
    }
    .line {
      line-height: 32px;
      .hour {
        margin-left: 50px;
      }
    }
    .plan {
      li {
        float: left;
        padding: 30px 20px;
        text-align: center;
        .cont {
          font-size: 14px;
          line-height: 30px;
        }
      }
    }
  }
}
.tab {
  width: 100%;
  background: #ffffff;
  margin-top:20px;
  margin-bottom: 20px;
  padding: 20px;
  border-radius: 6px;

  .block {
    // padding: 20px 0;
    .tab-title {
      line-height: 40px;
    }
    p {
      line-height: 30px;
    }
  }
  .cate {
    padding: 10px 20px;
    // max-height: 240px;
    // overflow: auto;
    .cate-tit {
      background: url("../assets/images/layer.png") no-repeat left;
      background-size: 24px 24px;
      padding-left: 40px;
      line-height: 40px;
      font-size: 18px;
    }
    .cate-list {
      display: block;
      line-height: 40px;
      padding: 0 20px;
      transition: 0.3s;
      cursor: pointer;
      &:hover {
        color: #409eff;
        .stop {
          background: url("../assets/images/stop1.png") no-repeat center;
          background-size: 100% 100%;
        }
      }
      .icon {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
      .progress {
        display: inline-block;
        vertical-align: middle;
        width: 16px;
        height: 16px;
        margin-right: 5px;
        // img{
        //   width: 100%;
        //   height: 100%;
        // }
      }
      .stop {
        background: url("../assets/images/stop.png") no-repeat center;
        background-size: 100% 100%;
      }
      /* .progress {
        display: inline-block;
        vertical-align: middle;
        width: 20px;
        height: 20px;
        background: url("../assets/images/finish.png") no-repeat left;
        background-size: contain;
        margin: 0 3px;
      }
      .video {
        display: inline-block;
        vertical-align: middle;
        width: 20px;
        height: 20px;
        background: url("../assets/images/stop.png") no-repeat left;
        background-size: contain;
        margin: 0 10px 0 3px;
      } */
    }
  }
  .practice {
    // border: 1px solid #ccc;
    padding: 12px 20px;
    border-radius: 6px;
    background: #eaeaea;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 10px;
    transition: 0.3s;
    &:hover {
      background: #d4d4d4;
    }
  }
  .empty {
    text-align: center;
    line-height: 100px;
  }
}
  .downloadDiv{
    width: 100%;
    background: #ffffff;
    margin-top:10px;
    padding: 20px;
    border-radius: 6px;
  }
</style>
